import React from 'react'

export const blockedMessageOf = (payload) => payload?.data?.blocked?.message || null

const EnrollmentBlocked = ({ message }) => (
  <div className="min-h-screen bg-background flex items-center justify-center px-4">
    <div className="border border-divider bg-surface shadow-lg rounded-2xl p-12 text-center max-w-md">
      <div className="text-xl font-bold text-text-primary mb-2">Please contact your representative</div>
      <p className="text-text-secondary">{message}</p>
    </div>
  </div>
)

export default EnrollmentBlocked
